import React , {useEffect, useState} from "react";
import { useParams , useHistory } from "react-router-dom";
import * as s from "./Files.styles";
import logo from "../../../assets/images/logo.png";
import * as actions from '../../../store/actions/index';
import { useSelector , useDispatch  } from "react-redux";

const Files = () => {
  let history = useHistory();
  let dispatch = useDispatch();
  let { clientId } = useParams();
  let { folderId } = useParams();
  let {folderName} = useParams();
 useEffect(() => {
    dispatch(actions.fetchFoldersUserAdmin(clientId))
 },[])
 
  return (
    <s.ScreenContainer>
      <s.FilesHeader>
        <s.Headers>
        <s.H1>Document folder</s.H1>
        <s.H3>{folderName}</s.H3>
        </s.Headers>
        <s.BtnsContainer>
      <s.DeleteBtn 
       onClick={() =>{
        history.push(`/clients/${clientId}`)
        dispatch(actions.deleteClientFolder(folderId))
       }
      }>
             Delete Folder
        </s.DeleteBtn>
        <s.RenameBtn 
       onClick={() =>{
        history.push(`/clients/${folderId}/${folderName}/rename-profile`)
       }
      }>
             Rename Folder
        </s.RenameBtn>
        
      </s.BtnsContainer>
      

        
        
      </s.FilesHeader>

      <s.Files>
        <s.singleFile>
          <s.LogoContainer>
            <s.LogoImage src={logo} />
          </s.LogoContainer>
          <s.H4>image name here</s.H4>
        </s.singleFile>
        <s.singleFile>
          <s.LogoContainer>
            <s.LogoImage src={logo} />
          </s.LogoContainer>
          <s.H4>image name here</s.H4>
        </s.singleFile>
        <s.singleFile>
          <s.LogoContainer>
            <s.LogoImage src={logo} />
          </s.LogoContainer>
          <s.H4>image name here</s.H4>
        </s.singleFile>
        <s.singleFile>
          <s.LogoContainer>
            <s.LogoImage src={logo} />
          </s.LogoContainer>
          <s.H4>image name here</s.H4>
        </s.singleFile>
        <s.singleFile>
          <s.LogoContainer>
            <s.LogoImage src={logo} />
          </s.LogoContainer>
          <s.H4>image name here</s.H4>
        </s.singleFile>
        <s.singleFile>
          <s.LogoContainer>
            <s.LogoImage src={logo} />
          </s.LogoContainer>
          <s.H4>image name here</s.H4>
        </s.singleFile>
        <s.singleFile>
          <s.LogoContainer>
            <s.LogoImage src={logo} />
          </s.LogoContainer>
          <s.H4>image name here</s.H4>
        </s.singleFile>
        <s.singleFile>
          <s.LogoContainer>
            <s.LogoImage src={logo} />
          </s.LogoContainer>
          <s.H4>image name here</s.H4>
        </s.singleFile>
      </s.Files>
    </s.ScreenContainer>
  );
};

export default Files;
